import React, { forwardRef, Fragment, useEffect, useMemo, useState } from 'react';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Close as CloseIcon, Visibility } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Slide from '@material-ui/core/Slide';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import { TextField } from '@material-ui/core';
import SweetAlert from 'react-bootstrap-sweetalert';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { wsGet, wsCreate } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';

import { Marker, InfoWindow, Polygon } from '@react-google-maps/api';
import { WithApp } from 'contexts/appContext';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { Link } from 'react-router-dom';
import wkt from 'wkt';
import { wsGetAll } from 'services/WService';
import AddressesSimilarityTable from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/AddressesSimilarityTable';
import LayerCombo from 'components/Tvendo/Common/LayerCombo';
import Legend from 'components/Tvendo/Common/Legend';
import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import useLayerContext from 'contexts/layerContext';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const useStyles = makeStyles((theme) => ({
  ...styles,
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  container: {
    marginTop: '20px',
  },
  divStyle: {
    padding: '4px',
    listStyle: 'none',
    background: '#c8f7ec',
    borderRadius: '5px',
    '& span': {
      fontSize: '15px',
      fontWeight: 500,
    },
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultMapCenter = {
  lat: -14.075338295892307,
  lng: -75.73423638548219,
};

export default WithApp(function CustomerModal(props) {
  const classes = useStyles();
  const [alert, setAlert] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [notify, showNotify] = useToasty(); //notificación despues de las

  const [openInfo, setOpenInfo] = useState(false);
  const [infoData, setInfoData] = useState({});
  const [zone, setZone] = useState();
  const [businessLinesUnilever, setBusinessLinesUnilever] = useState([]);
  const [selectedBusinessLine, setSelectedBusinessLine] = useState('N');

  const { open, setOpen, customerId, deleteCustomer, zoneId } = props;
  const { layers, selectedLayer, setSelectedLayer } = useLayerContext();
  // const [selectedLayer, setSelectedLayer] = useState();

  function confirm(status) {
    if (status) {
      if (
        approveAddress === false &&
        approveDocument === false &&
        approveName === false &&
        approveSecName === false &&
        approveLastNamePa === false &&
        approveLastNameMa === false &&
        approveEmail === false &&
        approveCellphone === false &&
        approveGeometry === false &&
        approveBusinessLine === false
      ) {
        showNotify('Seleccione al menos una opción a aprobar', 'warning');
        return;
      }
    }

    status
      ? setAlert(
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Está seguro de aprobar?"
            onConfirm={() => {
              let data = {
                ordm_customer_id: customerId,
              };
              if (approveBusinessLine) {
                if (selectedBusinessLine !== 'N') {
                  data.business_line_id = selectedBusinessLine;
                }
              }
              approveOrAnnull('ordm/customer/approve', data);
              hideAlert();
            }}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={classes.button + ' ' + classes.success}
            cancelBtnCssClass={classes.button + ' ' + classes.danger}
            confirmBtnText="Aceptar"
            cancelBtnText="Cancelar"
            showCancel
          >
            ¡Esta acción tiene consecuencias!
          </SweetAlert>,
        )
      : setAlert(
          <SweetAlert
            input
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Está seguro de anular?"
            onConfirm={(e) => {
              approveOrAnnull('ordm/customer/annular', {
                ordm_customer_id: customerId,
                observations: e,
              });
              hideAlert();
            }}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={classes.button + ' ' + classes.success}
            cancelBtnCssClass={classes.button + ' ' + classes.danger}
            confirmBtnText="Aceptar"
            cancelBtnText="Cancelar"
            showCancel
          >
            Ingrese el motivo por favor :)
          </SweetAlert>,
        );
  }
  const hideAlert = () => {
    setAlert(null);
  };

  //mapa
  const [mapCenter, setMapCenter] = useState(defaultMapCenter);
  const [marker, setMarker] = useState(null);

  const [bPartner, setBPartner] = useState({});
  const [customer, setCustomer] = useState({});
  const [seller, setSeller] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [originalAddress, setOriginalAddress] = useState(null);
  const [billAddress, setBillAddress] = useState(null);

  const [zoneGeometry, setZoneGeometry] = useState();
  const [routeGeometries, setRouteGeometries] = useState([]);
  const [routeDescription, setRouteDescription] = useState();

  const [approveAddress, setApproveAddress] = useState(false);
  const [replaceBillAddress, setReplaceBillAddress] = useState(false);
  const [approveDocument, setApproveDocument] = useState(false);
  const [approveName, setApproveName] = useState(false);
  const [approveSecName, setApproveSecName] = useState(false);
  const [approveLastNamePa, setApproveLastNamePa] = useState(false);
  const [approveLastNameMa, setApproveLastNameMa] = useState(false);
  const [approveEmail, setApproveEmail] = useState(false);
  const [approveCellphone, setApproveCellphone] = useState(false);
  const [approveGeometry, setApproveGeometry] = useState(false);
  const [approveBusinessLine, setApproveBusinessLine] = useState(false);

  const handleClose = () => {
    if(processing === true) return;
    setOpen(false);
    setApproveAddress(false);
    setApproveDocument(false);
    setApproveName(false);
    setApproveSecName(false);
    setApproveLastNamePa(false);
    setApproveLastNameMa(false);
    setApproveEmail(false);
    setApproveCellphone(false);
    setApproveGeometry(false);
    setMapCenter(defaultMapCenter);
    setMarker(null);
  };

  async function getCustomer() {
    let response = await wsGet('ordm/customer', customerId);
    if (response.success) {
      setCustomer(response.data.customer);
      setSeller(response.data.customer.seller);
      setSelectedLayer(
        layers.find((layer) => layer.base_canal_id === response.data.customer.seller.base_canal_id),
      );
      setAddresses(response.data.addresses);
      setBillAddress(response.data.bill_address);
      setOriginalAddress(response.data.original_address);
      setBPartner(response.data.business_partner || {});
      let coordenates = {
        lat: parseFloat(response.data.customer.latitude),
        lng: parseFloat(response.data.customer.longitude),
      };
      if (coordenates.lat !== 0) {
        setMapCenter(coordenates);
      }
      setMarker(coordenates);
      //address
    }
  }

  async function approveOrAnnull(entityAction, data, force = 'N') {
    if (marker !== null) {
      data.latitude = marker.lat;
      data.longitude = marker.lng;
    }

    if (selectedLayer === undefined || selectedLayer.id === undefined) {
      showNotify('Se tiene que seleccinar una capa', 'info');
      return;
    }

    data = {
      ...data,
      approveAddress,
      replaceBillAddress,
      approveDocument,
      approveName,
      approveSecName,
      approveLastNamePa,
      approveLastNameMa,
      approveEmail,
      approveCellphone,
      approveGeometry,
      approveBusinessLine,
      base_layer_id: selectedLayer.id,
      force,
    };

    setProcessing(true);
    let response = await wsCreate(entityAction, data);
    setProcessing(false);
    if (response.success) {
      showNotify(response.message);
      deleteCustomer(data.ordm_customer_id);
      handleClose();
    } else {
      if (response.force === true) {
        if (window.confirm(response.message)) {
          approveOrAnnull(entityAction, data, 'Y');
        }
      } else {
        showNotify(response.message, 'error');
      }
    }
  }

  function mapGeometry(point) {
    return { lng: point[0], lat: point[1] };
  }

  async function getZone(zoneId) {
    let response = await wsGet('base/zone', zoneId, {
      with_addresses: 'N',
    });
    if (response.success !== true) return;
    let { routes, ...zone } = response.data;
    setZone(zone);
    if (zone.geometry === null) return;
    let zoneGeometry = wkt.parse(zone.geometry);

    zoneGeometry.coordinates[0] = zoneGeometry.coordinates[0].map(mapGeometry);

    setZoneGeometry(zoneGeometry);
    let routeGeometries = routes
      .filter((route) => route.geometry !== null)
      .map((route) => {
        let routeGeometry = wkt.parse(route.geometry);
        routeGeometry.coordinates[0] = routeGeometry.coordinates[0].map(mapGeometry);
        routeGeometry.description = route.description;
        routeGeometry.layer = layers.find((layer) => layer.id === parseInt(route.base_layer_id));
        return routeGeometry;
      });
    setRouteGeometries(routeGeometries);
  }

  async function listBusinessLines() {
    let res = await wsGetAll('base/business-line?base_business_partner_id=1');
    setBusinessLinesUnilever(res.data);
  }

  useEffect(() => {
    listBusinessLines();
  }, []);

  useEffect(() => {
    if (businessLinesUnilever.length === 0) return;
    const selected = businessLinesUnilever.find(
      (item) => parseInt(item.id) === parseInt(customer.base_business_line_id),
    )?.id;
    if (selected !== undefined) {
      setSelectedBusinessLine(selected);
      return;
    }

    setSelectedBusinessLine(
      originalAddress?.business_lines.find((item) => item.CardCode === 'P20100003946')?.id || 'N',
    );
  }, [businessLinesUnilever, originalAddress, customer]);

  useEffect(() => {
    if (zoneId === undefined) return;
    getZone(zoneId);
  }, [zoneId]);

  useEffect(() => {
    if (open) getCustomer();
  }, [open]);

  const filteredRoutes = useMemo(() => {
    if (selectedLayer === undefined) return routeGeometries;
    if (selectedLayer.id === undefined) return routeGeometries;
    return routeGeometries.filter((route) => route.layer.id === selectedLayer.id);
  }, [selectedLayer, routeGeometries]);

  return (
    <Fragment>
      <Toasty action={notify} />
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                style={{ color: 'white' }}
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Aprobación del cliente
              </Typography>
            </Toolbar>
          </AppBar>

          <GridItem xs={12}>
            <h4>
              {customer.id === undefined
                ? 'Cargando...'
                : customer.new === 'Y'
                ? `Nuevo cliente: ${customer?.business_name}`
                : `Actualización de cliente: ${bPartner?.CardCode} - ${bPartner?.CardName}`}

              {bPartner.id !== undefined && (
                <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_SHOW}>
                  <Link
                    to={`/admin/socio-negocio/datos-maestros/clientes/${bPartner.id}`}
                    target="__blank"
                  >
                    <Visibility />
                  </Link>
                </AllowedGuard>
              )}
            </h4>
          </GridItem>
          {seller.id !== undefined && (
            <GridItem xs={12}>
              <h4>Vendedor: {seller.SlpName}</h4>
            </GridItem>
          )}
          <GridItem xs={12} sm={6} md={4}>
            <GridContainer>
              <GridItem xs={12}>
                <h4
                  style={{
                    color: '#22ca22',
                    fontWeight: 500,
                  }}
                >
                  Ruta: {routeDescription || 'Pase el mouse por un polígono'}
                </h4>
                {zone && <h4 style={{ fontWeight: 500 }}>Zona: {zone.description}</h4>}
              </GridItem>
              <GridItem xs={12}>
                <Legend
                  legends={[
                    {
                      imageSrc: '/img/marker.png',
                      title: 'Nueva ubicación',
                    },
                    {
                      imageSrc: '/img/mark.png',
                      title: 'Dirección original',
                    },
                    {
                      imageSrc: '/img/marker_gray.png',
                      title: 'Dirección fiscal',
                    },
                    {
                      imageSrc: '/img/GoogleMarker.png',
                      title: 'Direcciones cercanas',
                    },
                    {
                      imageSrc: '/img/mark_yellow.png',
                      title: 'Direcciones similares',
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            Dirección fiscal: {billAddress?.Address2}
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <GridContainer>
              <GridItem xs={12}>
                <LayerLegend />
              </GridItem>
              <GridItem xs={12}>
                <LayerCombo label="Capa" />
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={5}
            lg={4}
            className={classes.container}
            style={{ marginBottom: '120px' }}
          >
            <GoogleMapCustom
              mapContainerStyle={{
                width: '100%',
                height: '50%',
                minHeight: '600px',
              }}
              zoom={20}
              center={mapCenter}
              onClick={() => {
                setOpenInfo(false);
              }}
            >
              {filteredRoutes.map((route, index) => {
                return (
                  <Polygon
                    key={index}
                    onMouseOver={() => setRouteDescription(route.description)}
                    onMouseOut={() => setRouteDescription()}
                    options={{
                      fillColor: route.layer.color,
                    }}
                    paths={route.coordinates}
                  />
                );
              })}

              {marker !== null ? (
                marker.lat !== 0 ? (
                  <Marker
                    zIndex={100}
                    draggable
                    position={marker}
                    onDragEnd={(e) => {
                      setMarker({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                    }}
                    icon={'/img/marker.png'}
                  />
                ) : undefined
              ) : undefined}

              {originalAddress !== null ? (
                <Marker
                  position={{
                    lat: parseFloat(originalAddress.latitude),
                    lng: parseFloat(originalAddress.longitude),
                  }}
                  onClick={() => {
                    setOpenInfo(true);
                    setInfoData({
                      latitude: originalAddress.latitude,
                      longitude: originalAddress.longitude,
                      CardName: `Dirección original`,
                    });
                  }}
                  icon={'/img/mark.png'}
                />
              ) : undefined}

              {billAddress !== null && (
                <Marker
                  position={{
                    lat: parseFloat(billAddress.latitude),
                    lng: parseFloat(billAddress.longitude),
                  }}
                  onClick={() => {
                    setOpenInfo(true);
                    setInfoData({
                      latitude: billAddress.latitude,
                      longitude: billAddress.longitude,
                      CardName: `Dirección fiscal`,
                    });
                  }}
                  icon={'/img/marker_gray.png'}
                />
              )}

              {addresses.map((address, i) => {
                return !!address ? (
                  <Marker
                    position={{
                      lat: parseFloat(address.latitude),
                      lng: parseFloat(address.longitude),
                    }}
                    key={i}
                    onClick={() => {
                      setOpenInfo(true);
                      setInfoData(address);
                    }}
                    icon={
                      selectedAddresses.length === 0
                        ? undefined
                        : !!selectedAddresses.find((selected) => selected.id === address.id)
                        ? '/img/mark_yellow.png'
                        : undefined
                    }
                  />
                ) : undefined;
              })}
              {openInfo ? (
                <InfoWindow
                  position={{
                    lat: parseFloat(infoData.latitude),
                    lng: parseFloat(infoData.longitude),
                  }}
                  onCloseClick={() => {
                    setOpenInfo(false);
                    setInfoData({});
                  }}
                  options={{
                    pixelOffset: {
                      width: 0,
                      height: -25,
                    },
                  }}
                >
                  <div className={classes.divStyle}>
                    <li>
                      <span>Nombre: </span>
                      {infoData.CardName}
                    </li>
                    <li>
                      <span>Dir: </span>
                      {infoData.Address2}
                    </li>
                  </div>
                </InfoWindow>
              ) : undefined}
            </GoogleMapCustom>
          </GridItem>
          <GridItem xs={12} sm={12} md={7} lg={8}>
            <GridContainer>
              {/* Títulos */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <h4>Original</h4>
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <h4>Móvil</h4>
                </GridItem>
                <GridItem xs={2}>
                  <h4>Aprobar </h4>
                </GridItem>
              </GridContainer>

              {/* Dirección */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Dirección"
                      fullWidth
                      margin="normal"
                      value={bPartner.Address || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Dirección"
                    fullWidth
                    margin="normal"
                    value={customer.base_address_description || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveAddress}
                    disabled={customer.base_address_description === null}
                    onChange={(e, checked) => setApproveAddress(checked)}
                  />
                  <FormControlLabel
                    label="D.fiscal"
                    labelPlacement="end"
                    control={
                      <Checkbox
                        checked={replaceBillAddress}
                        disabled={approveAddress === false}
                        onChange={(e, checked) => setReplaceBillAddress(checked)}
                      />
                    }
                  />
                </GridItem>
              </GridContainer>

              {/* Nombre */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Primer Nombre"
                      fullWidth
                      margin="normal"
                      value={bPartner.first_name || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Primer Nombre"
                    fullWidth
                    margin="normal"
                    value={customer.first_name || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveName}
                    disabled={customer.first_name === null}
                    onChange={(e, checked) => setApproveName(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Segundo Nombre */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Segundo Nombre"
                      fullWidth
                      margin="normal"
                      value={bPartner.second_name || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Segundo Nombre"
                    fullWidth
                    margin="normal"
                    value={customer.second_name || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveSecName}
                    disabled={customer.second_name === null}
                    onChange={(e, checked) => setApproveSecName(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Apellido Paterno */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Apellido Paterno"
                      fullWidth
                      margin="normal"
                      value={bPartner.father_name || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Apellido Paterno"
                    fullWidth
                    margin="normal"
                    value={customer.father_name || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveLastNamePa}
                    disabled={customer.father_name === null}
                    onChange={(e, checked) => setApproveLastNamePa(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Apellido Materno*/}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Apellido Materno"
                      fullWidth
                      margin="normal"
                      value={bPartner.mothert_name || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Apellido Materno"
                    fullWidth
                    margin="normal"
                    value={customer.mothert_name || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveLastNameMa}
                    disabled={customer.mothert_name === null}
                    onChange={(e, checked) => setApproveLastNameMa(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* LicTradNum */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Documento"
                      fullWidth
                      margin="normal"
                      value={bPartner.LicTradNum || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Documento"
                    fullWidth
                    margin="normal"
                    value={customer.document_number || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveDocument}
                    disabled={customer.document_number === null}
                    onChange={(e, checked) => setApproveDocument(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Correo */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Correo"
                      fullWidth
                      margin="normal"
                      value={bPartner.E_Mail || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Correo"
                    fullWidth
                    margin="normal"
                    value={customer.email || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveEmail}
                    disabled={customer.email === null}
                    onChange={(e, checked) => setApproveEmail(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Celular */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Celular"
                      fullWidth
                      margin="normal"
                      value={bPartner.Cellular || ''}
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Celular"
                    fullWidth
                    margin="normal"
                    value={customer.phone_number || 'No modificado'}
                    disabled
                  />
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveCellphone}
                    disabled={customer.phone_number === null}
                    onChange={(e, checked) => setApproveCellphone(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Punto / Geometria */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <TextField
                      label="Latitud/Longitud"
                      fullWidth
                      margin="normal"
                      value={
                        originalAddress !== null
                          ? `${originalAddress.latitude} / ${originalAddress.longitude}`
                          : 'No existe punto'
                      }
                      disabled
                    />
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <TextField
                    label="Nuevo punto lat/lgn"
                    fullWidth
                    margin="normal"
                    value={marker !== null ? `${marker.lat} / ${marker.lng}` : 'No se marco punto'}
                    disabled
                  />
                </GridItem>

                <GridItem xs={2}>
                  <Checkbox
                    checked={approveGeometry}
                    disabled={customer.latitude === null || customer.latitude == '0'}
                    onChange={(e, checked) => setApproveGeometry(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Giros de negocio */}
              <GridContainer>
                {customer.new !== 'Y' && (
                  <GridItem xs={5}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Giro de negocio</InputLabel>
                      <Select
                        disabled={true}
                        value={
                          originalAddress?.business_lines.find(
                            (item) => item.CardCode === 'P20100003946',
                          )?.id || 'N'
                        }
                      >
                        <MenuItem value="N">No asignado</MenuItem>
                        {businessLinesUnilever.map((item) => {
                          return (
                            <MenuItem value={item.id} key={item.id}>
                              {item.description}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                )}
                <GridItem xs={5}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Giro de negocio (unilever)</InputLabel>
                    <Select
                      value={selectedBusinessLine || 'N'}
                      onChange={(e) => setSelectedBusinessLine(e.target.value)}
                    >
                      <MenuItem value="N">No asignado</MenuItem>
                      {businessLinesUnilever.map((item) => {
                        return (
                          <MenuItem value={item.id} key={item.id}>
                            {item.description}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={2}>
                  <Checkbox
                    checked={approveBusinessLine}
                    onChange={(e, checked) => setApproveBusinessLine(checked)}
                  />
                </GridItem>
              </GridContainer>

              {/* Observaciones */}
              <GridContainer>
                <GridItem xs={12}>
                  <TextField
                    label="Observaciones"
                    fullWidth
                    margin="normal"
                    value={customer.observations || ''}
                    disabled
                  />
                </GridItem>
              </GridContainer>

              <GridItem xs={12} sm={12} md={12}>
                {alert}
                <div style={{ float: 'right' }}>
                  <AllowedGuard permission={ConstantPermissions.ORDM_CUSTOMERS_APPROVE}>
                    <Button
                      color={props.themeContext.buttonColorSuccess}
                      disabled={processing}
                      onClick={() => {
                        confirm(true);
                      }}
                    >
                      Aprobar
                    </Button>
                  </AllowedGuard>
                  <AllowedGuard permission={ConstantPermissions.ORDM_CUSTOMERS_ANNULAR}>
                    <Button
                      color={props.themeContext.buttonColorDanger}
                      disabled={processing}
                      onClick={() => {
                        confirm(false);
                      }}
                    >
                      Anular
                    </Button>
                  </AllowedGuard>
                </div>
              </GridItem>
            </GridContainer>

            <GridItem xs={12}>
              <AddressesSimilarityTable
                addresses={addresses}
                addressString={bPartner.Address || customer.base_address_description}
                setOpenInfo={setOpenInfo}
                setInfoData={setInfoData}
                setSelectedAddresses={setSelectedAddresses}
              />
            </GridItem>
          </GridItem>
        </GridContainer>
      </Dialog>
    </Fragment>
  );
});
